import { DATA_TYPES } from './CommonConstants';

const LOOKUP_TYPES = {
  SUCCESS_PLAN_STATUS: 'SUCCESS_PLAN_STATUS',
  SUCCESS_PLAN_PROGRESS: 'SUCCESS_PLAN_PROGRESS',
  MILESTONE_STATUS: 'MILESTONE_STATUS',
  KPI_PROGRESS: 'KPI_PROGRESS',
};

export default LOOKUP_TYPES;

export const SUCCESS_PLAN_TABS = {
  MILESTONE: 'Milestone',
  KPI: 'KPI',
  NOTE: 'Note',
  FILE: 'File',
};

export const SUCCESS_PLAN_LEVEL = 'success_plan';

export const COLLABORATOR_DISPLAY_LIMIT = 3;

export const SUCCESS_PLAN_SIDE_BAR_ACTIONS = {
  EDIT: 'EDIT',
  COMPLETE: 'COMPLETE',
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  DUPLICATE: 'DUPLICATE',
  DUPLICATEMOVE: 'DUPLICATEMOVE',
};

export const SUCCESS_PLAN_ACTIONS = {
  ADD: 'Add',
  EDIT: 'Edit',
  VIEW: 'View',
  COMPLETE: 'Complete',
  IN_PROGRESS: 'In_Progress',
  DUPLICATE: 'Duplicate',
  DUPLICATE_MOVE: 'Duplicate_Move',
  ARCHIVE: 'Archive',
};

export const SUCCESS_PLAN_KPI_TYPES = {
  CURRENCY: 'currency',
  NUMERIC: 'numeric',
  PERCENTAGE: 'percentage',
};

export const SUCCESS_PLAN_KPI_CRITERIA = [
  { value: 'greater', label: 'is greater than' },
  { value: 'lesser', label: 'is less than' },
];

export const SUCCESS_PLAN_KPI_TEMPLATE_CRITERIA = [
  { value: 'greater', label: 'is greater than or equal to' },
  { value: 'lesser', label: 'is less than or equal to' },
];

export const SUCCESS_PLAN_KPI_TARGET_TYPE = [
  { value: 'currency', label: 'Currency' },
  { value: 'numeric', label: 'Numeric' },
  { value: 'percentage', label: 'Percentage' },
];

export const MILESTONE_SIDE_BAR_ACTIONS = {
  EDIT: 'EDIT',
  COMPLETE: 'COMPLETE',
  ARCHIVE: 'ARCHIVE',
};

export const KPI_ACTIONS = {
  EDIT: 'EDIT',
  COMPLETE: 'COMPLETE',
  ARCHIVE: 'ARCHIVE',
  LIST_EDIT: 'LIST_EDIT',
};

export const KPI_ACTIONS_V2 = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  COMPLETE: 'COMPLETE',
  ARCHIVE: 'ARCHIVE',
  LIST_EDIT: 'LIST_EDIT',
};

export const MAX_TASK_LIMIT = 20;
export const MAX_MILESTONE_LIMIT = 5;

export const ALL_SUCCESS_PLAN_STATUS = {
  PLANNED: 'PLANNED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
};

export const ALL_SUCCESS_PLAN_STATUS_MAPPING = {
  [ALL_SUCCESS_PLAN_STATUS.PLANNED]: {
    color: 'purple',
    displayName: 'Planned',
  },
  [ALL_SUCCESS_PLAN_STATUS.IN_PROGRESS]: {
    color: 'blue',
    displayName: 'In Progress',
  },
  [ALL_SUCCESS_PLAN_STATUS.COMPLETE]: {
    color: 'green',
    displayName: 'Completed',
  },
};

export const ENTITY_ID_NAME_MAPPING = {
  organizationId: 'organization',
  accountId: 'account',
};

export const ALL_SUCCESS_PLAN_PROGRESS = {
  ON_TRACK: 'ON_TRACK',
  AT_RISK: 'AT_RISK',
  OFF_TRACK: 'OFF_TRACK',
  SUCCESSFUL: 'SUCCESSFUL',
  PARTIAL: 'PARTIAL',
  MISSED: 'MISSED',
  DROPPED: 'DROPPED',
};

export const ALL_SUCCESS_PLAN_PROGRESS_MAPPING = {
  [ALL_SUCCESS_PLAN_PROGRESS.ON_TRACK]: {
    value: 'On Track',
    flagState: 'low',
  },
  [ALL_SUCCESS_PLAN_PROGRESS.AT_RISK]: {
    value: 'At Risk',
    flagState: 'urgent',
  },
  [ALL_SUCCESS_PLAN_PROGRESS.OFF_TRACK]: {
    value: 'Off Track',
    flagState: 'high',
  },
  [ALL_SUCCESS_PLAN_PROGRESS.SUCCESSFUL]: {
    value: 'Successful',
    flagState: 'low',
  },
  [ALL_SUCCESS_PLAN_PROGRESS.PARTIAL]: {
    value: 'Partial',
    flagState: 'none',
  },
  [ALL_SUCCESS_PLAN_PROGRESS.MISSED]: { value: 'Missed', flagState: 'normal' },
  [ALL_SUCCESS_PLAN_PROGRESS.DROPPED]: {
    value: 'Dropped',
    flagState: 'normal',
  },
};

export const SUCCESS_PLAN_TABLE_ACTIONS_TO_FETCH_DATA = ['paginate', 'sort'];

export const ALL_SUCCESS_PLAN_ENTITY_GROUP_KEYS = {
  ALL: 'all',
  ACCOUNT_SUCCESS_PLANS: 'accounts',
  ORGANIZATION_SUCCESS_PLANS: 'organizations',
  OVER_DUE: 'overdue',
};

export const ALL_SUCCESS_PLAN_STATUS_TYPES = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
};

export const SUCCESS_PLAN_TYPE_TITLES = {
  ALL_SUCCESS_PLANS: 'All Success Plans',
  MY_SUCCESS_PLANS: 'My Success Plans',
};

export const KPI_LINK_ATTRIBUTE_TYPES = [
  DATA_TYPES.number,
  DATA_TYPES.currency,
  DATA_TYPES.percentage,
];

export const DEFAULT_TABLE_SORT_SETTINGS = {
  page: 1,
  sortColumn: 'created',
  sortDirection: 'DESC',
};

export const TABLE_COLUMN_NAMES = {
  successPlanName: 'successPlanName',
  ownerDetail: 'ownerDetail',
  entityName: 'entityName',
  statusValue: 'statusValue',
  startDate: 'startDate',
  dueDate: 'dueDate',
  progressValue: 'progressValue',
  milestoneCompletionPercentage: 'milestoneCompletionPercentage',
  kpiCompletedPercentage: 'kpiCompletedPercentage',
  modified: 'modified',
};

export const FILTER_NAMES = {
  name: 'name',
  startDate: 'startDate',
  dueDate: 'dueDate',
  status: 'status',
  progress: 'progress',
  entityArchived: 'system:entityArchived',
  ownerId: 'ownerId',
  collaboratorId: 'collaboratorId',
  created: 'created',
  linkedOrganization: 'linkedOrganization',
  linkedAccount: 'linkedAccount',
};

export const EXCLUDED_TABLE_COLUMN_KEYS = [TABLE_COLUMN_NAMES.entityName];

export const EXCLUDED_FILTER_NAMES = [
  FILTER_NAMES.linkedOrganization,
  FILTER_NAMES.linkedAccount,
];

export const TWO_TONE_COLOR = '#cf3939';

export const MILESTONE_STATUS_LABEL_COLOR = {
  IN_PROGRESS: 'purple',
  COMPLETE: 'green',
};

export const MILESTONE_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
};

export const MILESTONE_ACTIONS = {
  EDIT: 'EDIT',
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN_PROGRESS',
  ARCHIVE: 'ARCHIVE',
  TASK_EDIT: 'TASK_EDIT',
  TASK_ADD: 'TASK_ADD',
  TASK_ARCHIVE: 'TASK_ARCHIVE',
  TASK_COMPLETE: 'TASK_COMPLETE',
  TASK_IN_PROGRESS: 'TASK_IN_PROGRESS',
};

export const TARGET_CRITERIA = {
  LESSER: 'lesser',
  GREATER: 'greater',
};

export const KPI_TARGET_TYPE = {
  CURRENCY: 'currency',
  NUMERIC: 'numeric',
  PERCENTAGE: 'percentage',
};

export const KPI_DATA_TYPE = {
  NUMBER: 'number',
};

export const MAX_START_TARGET_VALUE = 1000000000000000000;
export const MAX_START_TARGET_VALUE_ERROR_STRING = '1000,000,000,000,000,000';

export const SP_TEMPLATE_TYPES = {
  ACCOUNT: 'ACCOUNT',
  ORGANIZATION: 'ORGANIZATION',
};
